// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__tVyeH","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1318a"};